var _excluded = ["textSize"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/*

DEPRECATED - considered obsolete in October 2022

*/

import React from 'react';
import styled from 'styled-components';
import Input from "../form/Input/Input.js";
var StyledEditableText = styled(Input).withConfig({
  componentId: "CL__sc-88pkcd-0"
})(["background:transparent;border:none;border-bottom:1px solid transparent;padding:0;height:auto;border-radius:0;padding-left:0;padding-right:0;margin-top:0;margin-bottom:-1px;font:var(--", ");transition:border-color var(--hover-transition),padding var(--hover-transition);&:not(:disabled):hover{box-shadow:none;border-bottom:1px dotted ", ";}&:not(:disabled):focus-visible{box-shadow:none;border-bottom:1px solid ", ";padding-left:var(--spacing-1);padding-right:var(--spacing-1);}", ""], _ref => {
  var {
    textSize
  } = _ref;
  return textSize;
}, _ref2 => {
  var {
    error
  } = _ref2;
  return error ? 'var(--error-color)' : 'var(--highlight-color)';
}, _ref3 => {
  var {
    error
  } = _ref3;
  return error ? 'var(--error-color)' : 'var(--highlight-color)';
}, _ref4 => {
  var {
    error
  } = _ref4;
  return error && "\n    &:not(:disabled):not(:focus-visible) {\n      border-bottom: 1px dotted var(--error-color);\n    }\n  ";
});
var EditableText = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  var {
      textSize = 'body-text-medium'
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/React.createElement(StyledEditableText, _extends({
    ref: ref,
    textSize: textSize,
    type: "text"
  }, props));
});
export default EditableText;